import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Gallery from "../components/content/gallery"
import RichText from "../components/content/richText"

class ProjectTemplate extends React.Component {
  constructor(props) {
    super(props)
    this.state = { recordDiv: null, arrow: null }
    this.scrolltoBottom = this.scrolltoBottom.bind(this)
    this.checkArrow = this.checkArrow.bind(this)
  }

  componentDidMount() {
    let recordDiv = document.getElementById("record")
    this.setState({ recordDiv: recordDiv, arrow: false })
  }

  scrolltoBottom() {
    let recordDiv = this.state.recordDiv
    if (recordDiv.scrollTop < 40) {
      recordDiv.scrollTo({
        top: recordDiv.scrollHeight,
        left: 100,
        behavior: "smooth",
      })
    } else {
      recordDiv.scrollTo({
        top: 0,
        left: 100,
        behavior: "smooth",
      })
    }
  }

  checkArrow() {
    let recordDiv = this.state.recordDiv
    if (recordDiv.scrollTop < 40) {
      this.setState({ arrow: false })
    } else {
      this.setState({ arrow: true })
    }
  }

  render() {
    const project = this.props.data.contentfulRecord
    const siteTitle = this.props.data.site.siteMetadata.title
    const siteDescription = this.props.data.site.siteMetadata.description
    const projects = this.props.data.allContentfulRecord.edges
    const gallery = this.props.data.contentfulRecord.gallery
    const logo = this.props.data.logo
    const tickerItems = this.props.data.allContentfulTickerItems

    return (
      <Layout
        location={this.props.location}
        title={siteTitle}
        description={siteDescription}
        projects={projects}
        logo={logo}
        tickerItems={tickerItems}
      >
        <SEO title={project.title} />
        <section class="record" id="record" onScroll={this.checkArrow}>
          <div class="record-display">
            <Gallery gallery={gallery} />
            <div class="title-and-button">
              <div>
                <h1>{project.title}</h1>
                <h2>{project.producer}</h2>
              </div>
              <button onClick={this.scrolltoBottom}>
                <div id="arrow" class={this.state.arrow ? "flip" : ""}>
                  ↓
                </div>
              </button>
            </div>
          </div>
          <div class="record-info">
            <p>{project.releaseDate}</p>
            <p class="record-description">
              {project.childContentfulRecordDescriptionTextNode.description}
            </p>
            <RichText
              addClass={"tracklist"}
              content={
                project.childContentfulRecordTracklistRichTextNode.tracklist
              }
            />
            <RichText
              addClass={"credits"}
              content={project.childContentfulRecordCreditsRichTextNode.credits}
            />
          </div>
        </section>
      </Layout>
    )
  }
}

export default ProjectTemplate

export const pageQuery = graphql`
  query projectBySlug($slug: String!) {
    site {
      siteMetadata {
        title
        description
      }
    }
    allContentfulRecord {
      edges {
        node {
          title
          slug
          catalog
          sort
          releaseDate
          producer
          childContentfulRecordDescriptionTextNode {
            description
          }
          childContentfulRecordTracklistRichTextNode {
            tracklist
          }
          childContentfulRecordCreditsRichTextNode {
            credits
          }
          gallery {
            fluid(maxWidth: 800) {
              src
              sizes
              srcSet
              aspectRatio
            }
          }
        }
      }
    }
    logo: file(relativePath: { eq: "dustworldlogoblack.png" }) {
      childImageSharp {
        fixed(width: 120, height: 120) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    allContentfulTickerItems {
      nodes {
        tickerTitle
        tickerContent {
          tickerContent
        }
        createdAt
        link {
          link
        }
      }
    }
    contentfulRecord(slug: { eq: $slug }) {
      title
      slug
      catalog
      releaseDate
      producer
      sort
      childContentfulRecordDescriptionTextNode {
        description
      }
      childContentfulRecordTracklistRichTextNode {
        tracklist
      }
      childContentfulRecordCreditsRichTextNode {
        credits
      }
      gallery {
        fluid(maxWidth: 800) {
          src
          sizes
          srcSet
          aspectRatio
        }
      }
    }
  }
`
